// extracted by mini-css-extract-plugin
export default {"wrapper":"Categories_wrapper__XWhG4","categories":"Categories_categories__ejrCv"};